<template>
    <div class="calendar-card-info">
        <div class="calendar-card-date">
            <div class="calendar-card-date-text">{{dateText}}</div>
        </div>
        <div v-if="showInfo" class="calendar-card-items">
            <v-virtual-scroll :items="events" 
                min-height="140"
                max-height="220">
                <template v-slot:default="{ item }">
                    <calendar-card-event 
                    :color="item.color"
                    :eventName="item.eventName"
                    :text="item.text"/>
                </template>
            </v-virtual-scroll>
        </div>
        <div v-else class="calendar-card-date-no-events">
            <div class="calendar-card-date-no-events-text">
                <p>В этот день событий нет.</p>
                <!-- <p>Ближайшее событие пройдёт</p>  -->
                <!-- <p>{{ nearestEventText }}</p> -->
            </div>
        </div>
        <v-divider class="upcoming-events-calendar-card-calendar-divider"/>
        <v-btn
            class="upcoming-events-calendar-card-calendar-button"
            min-width="230"
            variant="outlined"
            color="#0075AA"
            @click="openCalendar">
            Открыть Календарь
        </v-btn>
    </div>
</template>
<script>

import CalendarCardEvent from '@/components/calendarCard/CalendarCardEvent.vue'
export default {
    name: 'UpcomingEventsCalendarCardInfo',
    components: {
        CalendarCardEvent
    },
    props: {
        date: {
            type: [Date, String],
            required: true
        },
        nearestEvent: {
            type: [Date, String],
            required: false
        },
        events: {
            type: Array,
            required: true
        }
    },
    computed: {
        dateText(){
            if(!(this.date instanceof Date)){
                return 'Не выбрана дата'
            }
            let month = this.date.getMonth()
            let day = this.date.getDate().toString()
            let monthNames = {
                0:'января',
                1:'февраля',
                2:'марта',
                3:'апреля',
                4:'мая',
                5:'июня',
                6:'июля',
                7:'августа',
                8:'сентября',
                9:'октября',
                10:'ноября',
                11:'декабря'
            }
            let monthName = monthNames[month]
            return 'Собятия ' + day + ' ' + monthName
        },
        nearestEventText(){
            if(!(this.nearestEvent instanceof Date)){
                return ''
            }
            let month = this.nearestEvent.getMonth()
            let day = this.nearestEvent.getDate().toString()
            let monthNames = {
                0:'января',
                1:'февраля',
                2:'марта',
                3:'апреля',
                4:'мая',
                5:'июня',
                6:'июля',
                7:'августа',
                8:'сентября',
                9:'октября',
                10:'ноября',
                11:'декабря'
            }
            let monthName = monthNames[month]
            return 'Ближайшее событие ' + day + ' ' + monthName
        },
        showInfo(){
            return this.events.length > 0
        }
    },
    methods:{
        openCalendar(){
            this.$router.push({"name": "UpcomingEventsPage"})
        }
    }
}
</script>